import restGql from 'graphql-tag';

import type {Payload} from 'web-app/api/clients/rest-types/create-billing-plan/create-billing-plan';

export type CreateBillingPlanBody = {
    plan: Payload;
};

export const CreateBillingPlan = restGql`#graphql
    mutation CreateBillingPlan(
        $input: CreateBillingPlanBody!
    ) {
        createBillingPlan(input: $input) @rest(
            type: "CreateBillingPlan", 
            method: "POST",
            path: "/v2/plans?preview=false&version=2",
            bodyKey: "input"
        ) {
            plan {
                id
                version
                childId
                pricingGroupId
                from
                sessionBookings {
                    sessionId
                    fundable
                    day
                    start
                    end
                    }
                productBookings {
                    amount
                    day
                    productId
                    }
                termTimeOnly
                billing {
                    id
                    invoices
                    weeksOfCare
                    title
                    }
                billingScheme
            }
        }
    }   
`;
